import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import API from 'app/api';

const constructUrl = (projectId, collectionId = '') =>
    `/project/${projectId}/collection${collectionId ? `/${collectionId}` : ''}`;

export const createCollection = createAsyncThunk('collection/create', async ({ projectId, collection }, { dispatch }) => {
    const { data } = await API.post(constructUrl(projectId), collection);
    dispatch(getAllCollections({ projectId }));
    return data;
});

export const updateCollection = createAsyncThunk('collection/update', async ({ projectId, id, collection }, { dispatch }) => {
    const { data } = await API.put(constructUrl(projectId, id), collection);
    dispatch(getAllCollections({ projectId }));
    return data;
});

export const getAllCollections = createAsyncThunk('collection/getAll', async ({ projectId }) => {
    const { data } = await API.get(constructUrl(projectId));
    return data;
});

export const getCollectionById = createAsyncThunk('collection/getById', async ({ projectId, id }) => {
    const { data } = await API.get(constructUrl(projectId, id));
    return data;
});

export const deleteCollection = createAsyncThunk('collection/delete', async ({ projectId, id }) => {
    await API.delete(constructUrl(projectId, id));
    return id;
});

const collectionSlice = createSlice({
    name: 'collection',
    initialState: {
        collections: {},
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllCollections.pending, (state) => { state.loading = true; state.error = null; })
            .addCase(getAllCollections.fulfilled, (state, action) => {
                state.loading = false;
                state.collections = action.payload.reduce((acc, col) => {
                    acc[col.Id ?? col.id] = col;
                    return acc;
                }, {});
            })
            .addCase(getAllCollections.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
            .addCase(createCollection.fulfilled, () => {})
            .addCase(updateCollection.fulfilled, () => {})
            .addCase(deleteCollection.fulfilled, (state, action) => {
                delete state.collections[action.payload];
            });
    },
});

export default collectionSlice.reducer;
